import { ComponentType, ReactNode, Ref } from 'react'

interface GuestCountersLimits {
    minAdults: number
    maxAdults: number
    minChildren: number
    maxChildren: number
    minPets: number
    maxPets: number
    maxTotalGuests: number
}

export interface GuestCountersProps extends Partial<GuestCountersLimits> {
    adultsCount: number
    childrenCount: number
    petsCount?: number
    onAdultsCountChange: (count: number) => void
    onChildrenCountChange: (count: number) => void
    onPetsCountChange?: (count: number) => void
    petsAllowed: boolean
}

export enum GuestPickerMode {
    MODAL = 'modal',
    WIDGET = 'widget',
}

export interface GuestPickerPassThroughProps extends GuestCountersProps {
    isOpen: boolean
    onOpen: () => void
    onClose: () => void
    error?: string
    showInputInModal?: boolean
    isRounded?: string
    border?: string
    widgetHeight?: string
    showEditIcon?: boolean
    isEnquiryPopup?: boolean
}

export interface GuestPickerModalProps extends GuestPickerPassThroughProps {
    onReset: () => void
    onClear: () => void
    onSubmit: () => void
    children?: ReactNode
}

export interface GuestPickerWidgetProps extends GuestPickerPassThroughProps {
    inputRef: Ref<HTMLElement>
    children?: ReactNode
}

export interface GuestPickerExclusiveProps {
    mode: GuestPickerMode
    modalComponent: ComponentType<GuestPickerModalProps>
    widgetComponent: ComponentType<GuestPickerWidgetProps>
}

export type GuestPickerProps = GuestPickerPassThroughProps & GuestPickerExclusiveProps
